import { fetchJourneyMasters } from './journeyMasterService';
import { journeyActions } from '../store/journeySlice';

export const buildJourneyMasterCacheKey = (masterType, stateID) => {
    const type = String(masterType ?? '').trim();
    const id = stateID != null ? String(stateID).trim() : '';
    return id ? `${type}_${id}` : type;
};

export const fetchJourneyMastersCached =
    (masterType, options = {}) => async (dispatch, getState) => {
        const filter = options?.filter;
        const stateID = options?.stateID;
        const cacheKey = buildJourneyMasterCacheKey(masterType, stateID);

        const state = getState();
        const cache = state.journey.apiCache?.[cacheKey];

        // Relationship rows saved before showRelationInNomineeOrAppointee existed
        // must be fetched again, or the nominee dropdown filters every row out.
        const staleRelationshipCache =
            masterType === 'relationshipdetails' &&
            Array.isArray(cache?.data) &&
            !cache.data.some(
                (row) =>
                    row != null &&
                    Object.prototype.hasOwnProperty.call(
                        row,
                        'showRelationInNomineeOrAppointee',
                    ),
            );

        // If already cached return cached
        if (cache?.data && !staleRelationshipCache) {
            return cache.data;
        }

        // Otherwise return from API
        const response = await fetchJourneyMasters(masterType, {
            filter,
            stateID,
        });

        // Backend returns { masterType, items, totalCount }; store the items array so consumers get a list
        const items = (response?.items && Array.isArray(response.items))
            ? response.items
            : (Array.isArray(response) ? response : []);

        // Store in Redux cache
        dispatch(
            journeyActions.setApiCache({
                key: cacheKey,
                data: items
            })
        );

        return items;
    };